import TWEEN from './tween.js'
import { FresnelShader } from './shader.js';

const THREE = require('three')
require('./OrbitControls.js')(THREE)

const app = (function() {

    let camera,
        controls,
        scene,
        mixer,
        renderer,
        raycaster = new THREE.Raycaster(),
        contain
    //鼠标划过的模型        

    function APPFN() {

        this.selectObj = []
        this.objects = []
        this.optionObj = []
        this.selectColor = new THREE.Color(0x2d442d)
        this.mouseoverColor = new THREE.Color(0xA8E7FF)
        this.mouse = new THREE.Vector2()

        //创建group树的时候做的映射表避免多次使用app.scene.getObjectByName影响性能 
        this.groupLinkToMesh = {}

        //上一步进行了什么操作
        this.preOpt = null
        this.mmObj = null

    }


    Object.assign(APPFN.prototype, {

        opt: {
            //透明的模型                         
            opacity: [],
            //隐藏的模型
            hide: [],
            //实体的模型
            opaque: [],
            //显示的模型
            show: [],
            //当前操作的步数记录  1显示 2隐藏  3透明 4实体
            step: []
        },

        //模型操作的一些flag
        flag: {
            slice: false,
            animate: true
        },

        init: function(dom) {

            contain = dom
            this.contain = contain
            camera = new THREE.PerspectiveCamera(50, window.innerWidth / window.innerHeight, 0.001, 100)
            camera.position.z = cameraZ 

            scene = new THREE.Scene()
            //scene.background = new THREE.Color(0xffffff)
            scene.updateMatrixWorld(true)
            scene.add(camera)

            const ambientLight = new THREE.AmbientLight(0xffffff, .3)
            scene.add(ambientLight)
            const dirLight = new THREE.PointLight(0xffffff, .5)
            camera.add(dirLight)

            /*renderer = new THREE.WebGLRenderer( { antialias: true,preserveDrawingBuffer:true ,alpha:true})*/
            renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
            renderer.setPixelRatio(window.devicePixelRatio)
            renderer.setSize(contain.getBoundingClientRect().width, contain.getBoundingClientRect().height)
            renderer.gammaInput = true;
            renderer.gammaOutput = true;
            renderer.gammaFactor = 1.8

            controls = new THREE.OrbitControls(camera, renderer.domElement);
            controls.target.set(0, 0, 0);
            controls.dynamicDampingFactor = 0.4
            controls.screenSpacePanning = true
            controls.rotateSpeed = 3
            controls.zoomSpeed = 2
            controls.staticMoving = true

            this.camera = camera
            this.controls = controls
            this.renderer = renderer
            this.scene = scene
            this.raycaster = raycaster

            contain.appendChild(renderer.domElement)
            window.addEventListener('resize', windowResize, false)


            //dom.addEventListener('touchstart', function(e) { onClick(e) }, false)
            renderer.domElement.addEventListener('mousemove', function(event) {
                let pos = {
                    x: event.clientX,
                    y: event.clientY
                }
                app.mousePick(pos)
            })

            let touchStart = false,
                startX = 0,
                startY = 0,
                nextX = 0,
                nextY = 0,
                moveDistance = 0
            renderer.domElement.addEventListener('mousedown', function(event) {
                touchStart = true
                nextX = startX = event.pageX
                nextY = startY = event.pageY
                moveDistance = 0
            }, false)
            renderer.domElement.addEventListener('mousemove', function(event) {
                if (!touchStart) return
                nextX = event.pageX
                nextY = event.pageY
                moveDistance = (nextY - startY) * (nextY - startY) + (nextX - startX) * (nextX - startX)
                if (moveDistance >= 30) {
                    touchStart = false
                }
            }, false)
            renderer.domElement.addEventListener('mouseup', function(e) {
                if (!touchStart) return
                onClick(e)
                nextX = startX = moveDistance = nextY = startY = 0
                touchStart = false
            }, false)

            renderer.domElement.addEventListener('touchstart', function(event) {
                const touches = app.getOriginalEvent(event).touches
                if (touches && touches.length === 1) {
                    event = touches[0]
                }
                touchStart = true
                nextX = startX = event.pageX
                nextY = startY = event.pageY
                moveDistance = 0
            }, false)
            renderer.domElement.addEventListener('touchmove', function(event) {
                const touches = app.getOriginalEvent(event).touches
                if (touches && touches.length === 1) {
                    event = touches[0]
                }
                if (!touchStart) return
                nextX = event.pageX
                nextY = event.pageY
                moveDistance = (nextY - startY) * (nextY - startY) + (nextX - startX) * (nextX - startX)
                if (moveDistance >= 30) {
                    touchStart = false
                }
            }, false)
            renderer.domElement.addEventListener('touchend', function(e) {
                const touches = app.getOriginalEvent(event).touches
                if (touches && touches.length === 1) {
                    event = touches[0]
                }
                if (!touchStart) return
                onClick(e)
                nextX = startX = moveDistance = nextY = startY = 0
                touchStart = false
            }, false)

            const shader = FresnelShader;
            const uniforms = THREE.UniformsUtils.clone(shader.uniforms);
            //uniforms[ "tCube" ].value = textureCube;
            const SkinMaterial = new THREE.ShaderMaterial({
                uniforms: uniforms,
                transparent: true,
                opacity: 0.8,
                shininess: 10,
                depthTest: true,
                depthWrite: false,
                metalness: 0,
                metalnessMap: null,
                vertexShader: shader.vertexShader,
                fragmentShader: shader.fragmentShader
            });
            this.SkinMaterial = SkinMaterial


            buildParentGroup(scene)

            function animate() {
                requestAnimationFrame(animate)
                //controls.update()
                TWEEN.update()
                renderer.render(scene, camera)
            }
            windowResize()
            animate()
        },


        //鼠标滑动模型变色
        changeMMDye: function(o) {
            if (!app.mmObj) return
            var aa = app.mmObj.material
            if (aa.length) {
                for (var i = 0; i < aa.length; i++) {
                    if (o) {
                        aa[i].color = this.mouseoverColor
                    } else {
                        aa[i].color = aa[i].originalColor
                    }
                }
            } else {
                if (o) {
                    aa.color = this.mouseoverColor
                } else {
                    aa.color = aa.originalColor
                }
            }
        },


        mousePick: function(pos, component) {
            var SELECTED = null
            app.mouse.x = ((pos.x) / window.innerWidth) * 2 - 1
            app.mouse.y = -((pos.y) / window.innerHeight) * 2 + 1

            raycaster.setFromCamera(app.mouse, camera)
            var intersects = raycaster.intersectObjects(app.objects)

            if (intersects.length > 0) {
                SELECTED = intersects[0].object

                //显示名字
                //$moveName.show().html(app.GetChinese(SELECTED.parent.cnName))

                let group = SELECTED.dataParent

                if (SELECTED) {
                     // component.setState({
                     //     mousemoveName: app.GetChinese(group.cnName)
                     // })

                    if (SELECTED === app.mmObj) return
                    if (group === app.selectObj[0]) return

                    if (app.mmObj) {
                        app.changeMMDye(false)
                        app.mmObj = null
                    }

                    app.mmObj = SELECTED
                    app.changeMMDye(true)
                }

                /*} else if (SELECTED.role === 'SPRITE' && SELECTED.xueWeiParent.visible) {
                    app.clickOption(SELECTED.xueWeiParent.dataParent)
                }
                */

            } else {

                //先把上次鼠标滑过的模型的颜色还原
                if (app.mmObj && app.mmObj.dataParent != app.selectObj[0]) {
                    app.changeMMDye(false)
                }
                /*component.setState({
                    mousemoveName: null
                })*/
                app.mmObj = null
            }
        },


        calcPosition: function(Mesh) {
            Mesh.updateMatrixWorld(true)
            Mesh.matrixWorldNeedsUpdate = true
            Mesh.geometry.computeBoundingBox()
            var boundingBox = Mesh.geometry.boundingBox
            var position = new THREE.Vector3()
            position.subVectors(boundingBox.max, boundingBox.min)
            position.multiplyScalar(0.5)
            position.add(boundingBox.min)
            position.applyMatrix4(Mesh.matrixWorld)
            return position
        },


        resetControl: function() {

            app.controls.reset()
            /*WEEN.removeAll()
            new TWEEN.Tween(app.camera.position)
                .to({ x: 0, y: 0, z: .1 }, 600)
                .easing(TWEEN.Easing.Exponential.Out)
                .start()*/
        },


        //获取中文名称
        GetChinese: function(strValue) {
            if (strValue != null && strValue != "") {
                var reg = /[\u4e00-\u9fa5]/g;
                let tamp = strValue.match(reg)
                if (tamp) return tamp.join("");

            } else
                return "";
        },
        //转义xml与fbx mesh名字匹配
        adjustName: function(str) {
            let dotArr = [':', ',', ';', '(', ')', "'", "-", "]", "[", "+"]
            if (!str) return
            let result = str.replace(/ /g, '_');
            dotArr.forEach(function(item, index) {
                result = result.split(item)
                result = result.join('_')
            })
            return result
        },

        getOriginalEvent: function(event) {
            if (event && typeof event.originalEvent !== "undefined") {
                event = event.originalEvent
            }
            return event
        }

    })


    function buildParentGroup(parent) {

        const rootRroup = new THREE.Group()
        searchLoop(fff, rootRroup)

        function searchLoop(arr, group) {
            if (arr.length) {
                arr.forEach(function(child, index) {
                    let _group = new THREE.Group()
                    let adjustObjName = app.adjustName(child["$"]["o"])
                    //先标记下是否是透明过
                    _group['name'] = 'Group_' + adjustObjName
                    _group["objName"] = child["$"]["o"]
                    _group["cnName"] = child["$"]["c"]

                    if (child["s"] !== "" && child["s"] !== undefined) {
                        _group["sysNote"] = child["s"]
                    } else if (child["t"] !== "" && child["t"] !== undefined) {
                        _group["sysNote"] = child["t"]["s"]
                    } else {
                        _group["sysNote"] = ''
                    }

                    app.groupLinkToMesh[adjustObjName] = _group

                    group.add(_group)
                    if (child.ch) {
                        return searchLoop(child.ch.sub, _group)
                    }
                })
            } else {
                let _group = new THREE.Group()
                let adjustObjName = app.adjustName(arr["$"]["o"])

                _group.opacity = false
                _group['name'] = 'Group_' + adjustObjName
                _group["objName"] = arr["$"]["o"]
                _group["cnName"] = arr["$"]["c"]

                if (arr["$"]["type"] !== undefined) {

                } else {
                    _group["role"] = 'system'
                }
                if (arr["$"]["ids"] !== undefined) {
                    _group["ids"] = arr["$"]["ids"]
                }

                if (arr["$"]["l"] !== undefined) {
                    _group["layer"] = arr["$"]["l"]
                }
                if (arr["s"] !== "" && arr["s"] !== undefined) {
                    _group["sysNote"] = arr["s"]
                } else if (arr["t"] !== "" && arr["t"] !== undefined) {
                    _group["sysNote"] = arr["t"]["s"]
                } else {
                    _group["sysNote"] = ''
                }

                app.groupLinkToMesh[adjustObjName] = _group

                group.add(_group)
                if (arr.ch) {
                    return searchLoop(arr.ch.sub, _group)
                }
            }
        }
        parent.add(rootRroup)
    }



    function windowResize() {
        camera.aspect = contain.getBoundingClientRect().width / contain.getBoundingClientRect().height
        camera.updateProjectionMatrix()
        renderer.setSize(contain.getBoundingClientRect().width, contain.getBoundingClientRect().height)
        controls.update()
    }

    //鼠标点击模型事件
    function onClick(event) {

        if (!event.clientX && event.changedTouches) {
            event = event.changedTouches[0]
        }
        let SELECTED = null
        app.mouse.x = ((event.clientX - contain.getBoundingClientRect().left) / contain.getBoundingClientRect().width) * 2 - 1
        app.mouse.y = -((event.clientY - contain.getBoundingClientRect().top) / contain.getBoundingClientRect().height) * 2 + 1
        raycaster.setFromCamera(app.mouse, camera)
        let intersects = raycaster.intersectObjects(app.objects)
        
        //选中了
        if (intersects.length > 0) {

            SELECTED = intersects[0].object

            if (SELECTED.name.indexOf('_OP') >= 0) {
                if (intersects[1]) {
                    SELECTED = intersects[1].object
                } else {
                    return
                }
            }

            app.clickOption(SELECTED.dataParent)

            //为未点中隐藏操作面板(隐藏显示)
        } else {
            app.optionBar.setState({
                show: false,
                cnName: null,
                sysNote: null
            })

            if (app.mmObj) {
                app.changeMMDye(false)
            }
            app.mmObj = null
        }
    }

    const app = new APPFN()
    return app

})()


export default app


// WEBPACK FOOTER //
// ./src/pages/webgl/src/app.js